import {
  POS_REFUND_LOOKING,
  POS_REFUND_LOOKUP,
  POS_REFUND_LOOKUP_CLEAR,
  POS_REFUND_BUSY,
  POS_REFUND_DONE,
  POS_REFUND_ERROR,
  POS_REFUND_CLEAR_LAST,
} from "./actionTypes";

const initialState = {
  looking: false, // resolving a scanned receipt code
  lookup: null, // the bill + what is still refundable on it
  busy: false, // a refund is being sent to the gateway
  last: null, // the credit slip just issued
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_REFUND_LOOKING:
      return { ...state, looking: !!action.payload, error: null };

    case POS_REFUND_LOOKUP:
      return { ...state, looking: false, lookup: action.payload, error: null };

    case POS_REFUND_LOOKUP_CLEAR:
      return { ...state, looking: false, lookup: null, error: null };

    case POS_REFUND_BUSY:
      return { ...state, busy: !!action.payload, error: null };

    case POS_REFUND_DONE:
      return { ...state, busy: false, last: action.payload, error: null };

    case POS_REFUND_CLEAR_LAST:
      return { ...state, last: null };

    case POS_REFUND_ERROR:
      return { ...state, looking: false, busy: false, error: action.payload };

    default:
      return state;
  }
}
